import React from 'react';
import { useDispatch } from 'react-redux';
import { toggleSocialAccountView } from 'slices/ui/reducer';
import { AppDispatch } from 'store';
import { getSocialAccountProfileURL } from 'utils/helpers';

interface SocialAccountHandleProps {
    socialAccountId?: string | null;
    handle?: string | null;
    platform?: string | null;
    className?: string;
    showAt?: boolean;
    showExternalLink?: boolean;
    influencerId?: string | null;
    children?: React.ReactNode;
}

const SocialAccountHandle: React.FC<SocialAccountHandleProps> = ({
    socialAccountId,
    handle,
    platform,
    className = '',
    influencerId,
    showAt = true,
    showExternalLink = false,
    children,
}) => {
    const dispatch: AppDispatch = useDispatch();

    if (!handle) return null;

    const label = children ?? (showAt ? (handle.startsWith('@') ? handle : `@${handle}`) : handle);

    const openView = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (socialAccountId) {
            dispatch(toggleSocialAccountView({ socialAccountId, influencerId: influencerId ?? undefined }));
        }
    };

    return (
        <span className={`social-account-handle d-inline-flex align-items-center gap-1 ${className}`.trim()}>
            {socialAccountId ? (
                <button
                    type="button"
                    className="btn btn-link p-0 text-decoration-none social-account-handle__btn"
                    onClick={openView}
                >
                    {label}
                </button>
            ) : (
                <span>{label}</span>
            )}
            {showExternalLink && platform && (
                <a
                    href={getSocialAccountProfileURL(handle, platform)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-account-handle__external"
                    onClick={(e) => e.stopPropagation()}
                    aria-label="Open profile on platform"
                >
                    <i className="ri-external-link-line" />
                </a>
            )}
        </span>
    );
};

export default SocialAccountHandle;
